import type { NextPage } from 'next';

import AboutHeader from 'components/about/AboutHeader';
import OurPrinciples from 'components/about/OurPrinciples';
import MeetTheTeam from 'components/about/MeetTheTeam';
import { Members } from 'components/about/MeetTheTeam/Members.tsx';
import { WeAreHiring } from 'components/about/WeAreHiring';
import { OurCulture } from 'components/about/OurCulture';
import { MetaTags } from 'components/common';

const About: NextPage = () => {
  return (
    <>
      <MetaTags
        title="A team dedicated to Startup Fundraising"
        description="POD is a Bengaluru-based fundraising platform aims to aspire and nurture a healthy ecosystem for investing and fundraising in Indian startups."
        imageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}pod-logo.png`}
        url={process.env.NEXT_PUBLIC_FRONTEND_URL!}
        keywords="Startup Fundraising"
      />
      <AboutHeader />
      <OurPrinciples />
      <MeetTheTeam />
      <Members />
      <WeAreHiring />
      <OurCulture />
    </>
  );
};

export default About;
